// prettier-ignore
export const MetaDataActionTypes = {
  SET_SPORT_DATA: 'SET_SPORT_DATA',
  SET_COMPETITION_DATA: 'SET_COMPETITION_DATA',
  SET_GAME_DATA: 'SET_GAME_DATA',
  SET_ALL_DATA: 'SET_ALL_DATA'
};
